import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { Button, Stack } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import CompetencyToLevelTab from "./compToLevel";
import CompetencyToJobTab from "./compToJob";
import CompetencyTrainingTab from "./compTraining";
import { useTranslation } from "react-i18next";
import { useAuth } from "context/authContext";
import { hasEditAccess } from "services/utils";
import { buttonStyles } from "services/utils";
import CompAssessments from "./compAssessments";

// Common button styles

const MyCompetencies = () => {
  const { t } = useTranslation();
  const { employee, modules } = useAuth();
  const [view, setView] = useState(0); //
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(hasEditAccess(modules, "Competencies", employee));
  }, []);
  return (
    <>
      <MDBox>
        <MDBox pb={2}>
          {/* Buttons for Switching Views */}
          <Stack
            direction={{ xs: "column", sm: "row" }} // Stacked on xs, row on sm and larger
            spacing={2} // Adds space between buttons
            alignItems="center" // Centers buttons
          >
            <Button
              sx={buttonStyles(view === 0)}
              variant={view === 0 ? "contained" : "outlined"}
              onClick={() => setView(0)}
            >
              {t("admin.competency.competencyToLevel")}
            </Button>

            <Button
              sx={buttonStyles(view === 1)}
              variant={view === 1 ? "contained" : "outlined"}
              onClick={() => setView(1)}
            >
              {t("admin.competency.competencyToJob")}
            </Button>

            <Button
              sx={buttonStyles(view === 2)}
              variant={view === 2 ? "contained" : "outlined"}
              onClick={() => setView(2)}
            >
              {t("admin.competency.compAssessments")}
            </Button>
          </Stack>
        </MDBox>
      </MDBox>

      {view === 0 ? (
        <CompetencyToLevelTab canEdit={canEdit} />
      ) : view === 1 ? (
        <CompetencyToJobTab canEdit={canEdit} />
      ) : (
        <CompAssessments />
      )}
    </>
  );
};

export default MyCompetencies;
